var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { Box, LinearProgress, Typography, Grid } from '@mui/material';
import { offerList as offerListApi } from '../../api';
import { useRoaster } from '../../hooks/useRoaster';
import { useRequest } from '../../hooks/requestHook';
import { useBidColumns } from '../../hooks/useColumns';
import BidsTable from '../organisms/BidsTable';
import PageLayout from '../atoms/PageLayout';
import { useTranslation } from 'react-i18next';
import LabeledGridItem from '../atoms/LabeledGridItem';
import BidStatusTag from '../atoms/BidStatusTag';
var GridContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiGrid-root {\n    padding: 0 24px;\n    margin-bottom: 20px;\n  }\n"], ["\n  &.MuiGrid-root {\n    padding: 0 24px;\n    margin-bottom: 20px;\n  }\n"])));
var StyledTypography = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.MuiTypography-root {\n    margin-bottom: 10px;\n  }\n"], ["\n  &.MuiTypography-root {\n    margin-bottom: 10px;\n  }\n"])));
var RoasterAuctionPage = function () {
    var _a = useParams(), _b = _a.offerListId, offerListId = _b === void 0 ? '' : _b, _c = _a.offerId, offerId = _c === void 0 ? '' : _c;
    var t = useTranslation().t;
    var _d = React.useState(false), loading = _d[0], setLoading = _d[1];
    var _e = React.useState(), offerList = _e[0], setOfferList = _e[1];
    var _f = React.useState(), offer = _f[0], setOffer = _f[1];
    var _g = React.useState([]), auctionResultBids = _g[0], setAuctionResultBids = _g[1];
    var getOfferList = useRequest(offerListApi.get);
    var getAuctionResultBids = useRequest(offerListApi.auctionResult);
    var bidColumns = useBidColumns({ linkPrefix: '/roaster' });
    var roaster = useRoaster().roaster;
    var isUSRoaster = React.useMemo(function () { var _a; return ((_a = roaster === null || roaster === void 0 ? void 0 : roaster.country) === null || _a === void 0 ? void 0 : _a.code) === 'US'; }, [roaster]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getOfferList({ id: offerListId })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setOfferList(response);
                        setOffer(response.offers.find(function (offer) { return offer.id === offerId; }));
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [offerListId, offerId, getOfferList]);
    React.useEffect(function () {
        if (!offer || !offerList)
            return;
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getAuctionResultBids({
                                offerListId: offerList.id,
                                offerId: offer.id,
                            })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setAuctionResultBids(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [offer, getAuctionResultBids, offerList]);
    var roasterCompletedBid = React.useMemo(function () {
        if (auctionResultBids.length === 0)
            return;
        return auctionResultBids.find(function (bid) { return bid.own && ['won', 'lost'].includes(bid.status); });
    }, [auctionResultBids]);
    var columns = React.useMemo(function () { return [
        bidColumns.roasterFilteredName,
        isUSRoaster ? bidColumns.fobPriceUsdPerLb : bidColumns.fobPrice,
        bidColumns.quantity,
        bidColumns.wonQuantity,
        bidColumns.bidAt,
        bidColumns.status,
    ]; }, [bidColumns]);
    if (loading || !offerList || !offer)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { title: t('pages.roasterAuction.title', {
            offerListName: offerList.name,
            lotNumber: offer.lotNumber,
        }), backLink: true, backLinkTo: '/roaster' },
        roasterCompletedBid && (React.createElement(React.Fragment, null,
            React.createElement(StyledTypography, { variant: "h4" }, t('pages.roasterAuction.roasterAuctionResult')),
            React.createElement(GridContainer, { container: true },
                roasterCompletedBid.status === 'won' && (React.createElement(React.Fragment, null,
                    React.createElement(LabeledGridItem, { label: t('params.bid.fobPrice'), value: roasterCompletedBid.fobPrice }),
                    React.createElement(LabeledGridItem, { label: t('params.bid.wonQuantity'), value: roasterCompletedBid.wonQuantity }))),
                React.createElement(LabeledGridItem, { label: t('params.bid.status'), value: React.createElement(BidStatusTag, { bid: roasterCompletedBid }) })))),
        React.createElement(StyledTypography, { variant: "h4" }, t('pages.roasterAuction.auctionResult')),
        React.createElement(BidsTable, { bids: auctionResultBids, columns: columns, role: "roaster" }),
        isUSRoaster && (React.createElement(Box, { mt: 2 },
            React.createElement(Typography, { color: "error", variant: "caption", paragraph: true }, t('pages.roasterOrder.explanationAuctionWithFobPriceUsdPerLb'))))));
};
export default RoasterAuctionPage;
var templateObject_1, templateObject_2;
